import {helpers} from "../helpers";
import {EventEmitter} from "./EventEmitter";
import {arrayHelper} from "../helpers/ArrayHelper";
import {translator} from "../services/TranslatorService";

export class PriceLegend {
	/**
	 * @param params {Object}
	 * @param params.containerClassName {String}
	 */
	constructor({containerClassName} = {}) {
		this.emitter = new EventEmitter();
		this.containerClassName = containerClassName || "js-stadium-zones";

		this.init();
	}

	get $container() {
		return $(`.${this.containerClassName}`);
	}

	init() {
		$(document).on("click", ".js-prices-reset", e => {
			this.reset();
			this.emitter.emit("event:reset");
			return $(e.currentTarget).hide();
		});
	}

	on(action, fn) {
		if (action === "change") {
			this.emitter.subscribe("event:change-input", priceLegends => fn(priceLegends));
		}
		if (action === "reset") {
			this.emitter.subscribe("event:reset", () => fn());
		}
	}

	/**
	 * Создает легенды цен
	 * @param zones {Array} [
	 *   {zone, price, color, free, all}, ...
	 * ]
	 * @param params {Object} { showFreePlaces }
	 */
	render(zones = [], params = {}) {
		this.$container.html("");

		const seatsEndings = [
			translator.t("event", "seat"),
			translator.t("event", "seats"),
			translator.t("event", "seats "),
		];

		if (params.joinEqualPrices) zones = this.joinZonesByEqualPrices(zones);

		zones.sort((a, b) => a.price - b.price);
		$.each(zones, (i, zone) => {
			const freeText = `, ${translator.t("main", "left")} ${zone.free} ${helpers.wordEnding(
				zone.free,
				seatsEndings
			)}`;

			this.$container.append(
				this.createPriceLegendByZone(zone, {
					usePrimaryColor: !!params.usePrimaryColor,
					freeText: params.showFreePlaces ? freeText : "",
				})
			);
		});

		if (!helpers.isDesktop.matches && params.mobileLastSlot)
			this.$container.append(params.mobileLastSlot);

		this.addListenerToInputs();
	}

	renderHtml(html = "") {
		return this.$container.html(html);
	}

	joinZonesByEqualPrices(zones) {
		let uniqueZones = arrayHelper.uniqueArrayByProperty(zones, "price");
		zones = uniqueZones.map(zone => {
			const equalPrices = zones.filter(z => z.zone !== zone.zone && z.price === zone.price);
			equalPrices.forEach(ep => {
				zone.free += ep.free;
				zone.all += ep.all;
			});
			return zone;
		});
		return zones;
	}

	reset() {
		$(this.$container.find("input[type=checkbox]")).prop("checked", false);
	}

	show() {
		return this.$container.show();
	}

	hide() {
		return this.$container.hide();
	}

	createPriceLegendByZone(zone, params = {}) {
		return `<label class="price-legend ${params.usePrimaryColor ? "price-legend_primary" : ""}"
									 style="border-color: ${zone.color}"
              >
							<input class="price-legend__input" type="checkbox" data-price="${zone.price}" data-zone-id="${
			zone.zone
		}">
							<span class="price-legend__content">
								<span class="price-legend__color" style="background-color: ${zone.color}"></span>
								<span class="price-legend__text">
                  ${zone.price + " ₽" + '<span class="price-legend__text_free">' + (params.freeText ? params.freeText : "") + '</span>'}
                </span>
							</span>
						</label>`;
	}

	addListenerToInputs() {
		const $inputs = this.$container.find("input[type=checkbox]");
		/* Обработчик для фильтра по легендам цен */
		$($inputs).on("change", () => {
			const priceLegends = [];
			$.each($($inputs), (index, input) => {
				if ($(input).is(":checked")) {
					priceLegends.push({
						price: Number($(input).attr("data-price")),
						zoneId: Number($(input).attr("data-zone-id")),
					});
				}
			});

			/* Показать кнопку очистки если выбрали несколько цен */
			if (this.$container.find("input:checked").length > 1) {
				$(".js-prices-reset").show();
			} else {
				$(".js-prices-reset").hide();
			}

			this.emitter.emit("event:change-input", priceLegends);
		});
	}
}
